import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { auth } from '../api';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      await auth.requestPasswordReset(email);
      setMessage('Si cet email existe, un lien de réinitialisation a été envoyé.');
      setEmail('');
    } catch (err) {
      setError('Erreur lors de la demande');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container" style={{ maxWidth: '500px', marginTop: '100px' }}>
      <div className="card">
        <h1 style={{ textAlign: 'center', color: '#667eea', marginBottom: '10px' }}>
          🪁 ManaQuest Booking
        </h1>
        <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>Mot de passe oublié</h2>

        {error && <div className="error">{error}</div>}
        {message && <div className="success">{message}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="votre@email.com"
              required
              disabled={loading}
            />
          </div>

          <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={loading}>
            {loading ? 'Envoi...' : 'Envoyer le lien de réinitialisation'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <Link to="/login" style={{ color: '#667eea' }}>← Retour à la connexion</Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;